import { render, staticRenderFns } from "./techCard.vue?vue&type=template&id=438ad7f6&"
import script from "./techCard.vue?vue&type=script&lang=js&"
export * from "./techCard.vue?vue&type=script&lang=js&"
import style0 from "./techCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports